define.alias("shared/components/shared/ui/profile-color-option", "calendar/components/shared/ui/profile-color-option");